import { type OpenApiSchemaCharacteristicDisplayType } from '#shared/api/schema';

export const CHARACTERISTIC_DISPLAY_TYPE_MAP: {
    [key in OpenApiSchemaCharacteristicDisplayType]: { displayType: key; name: string };
} = {
    SELECT: {
        displayType: 'SELECT',
        name: 'Выбор из списка',
    },
    TEXT: {
        displayType: 'TEXT',
        name: 'Текстом',
    },
    IMAGE: {
        displayType: 'IMAGE',
        name: 'Изображениями',
    },
    COLOR: {
        displayType: 'COLOR',
        name: 'Цветом',
    },
};
